import axios from "../../axiosConfig";
import { truncateEmail } from "../../Utilities/utils";

export const insertUpdateComments = async ({ commentData, token, item, accounts }) => {
  if (!token || !commentData) throw new Error("Missing token or comment data");

  const endpointUrl = `/insertUpdateOrderComment?&orderCommId=${encodeURIComponent(0)}&orderCommDesc=${encodeURIComponent(commentData.Comment)}&orderDetailId=${encodeURIComponent(item.orderDetailId)}&author=${encodeURIComponent(truncateEmail(accounts[0].username, 50))}`;

  const response = await axios.post(endpointUrl, null, {
    headers: {
      Authorization: token,
    },
  });

  return response.data;
};